function pad2(n) {
  return String(n).padStart(2, "0");
}

export function epochSecToLocalInputValue(sec) {
  const n = Number(sec || 0);
  if (!Number.isFinite(n) || n <= 0) return "";
  const d = new Date(n * 1000);
  // Use UTC consistently for admin time input fields.
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}T${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())}`;
}

export function localInputValueToEpochSec(v) {
  const s = String(v || "").trim();
  if (!s) return 0;
  // Accept YYYY-MM-DDTHH:MM (with optional seconds) and interpret as UTC.
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
  if (!m) return 0;
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const hour = Number(m[4]);
  const minute = Number(m[5]);
  const second = Number(m[6] || 0);
  if (
    !Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day) ||
    !Number.isInteger(hour) || !Number.isInteger(minute) || !Number.isInteger(second)
  ) return 0;
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour < 0 || hour > 23 || minute < 0 || minute > 59 || second < 0 || second > 59) return 0;
  const ms = Date.UTC(year, month - 1, day, hour, minute, second);
  if (!Number.isFinite(ms)) return 0;
  return Math.floor(ms / 1000);
}

export function epochSecToLocalDateValue(sec) {
  const v = epochSecToLocalInputValue(sec);
  return v ? v.split("T")[0] : "";
}

export function epochSecToLocalTimeValue(sec) {
  const v = epochSecToLocalInputValue(sec);
  return v ? v.split("T")[1] : "";
}

export function localDateTimePartsToEpochSec(dateStr, timeStr) {
  const d = String(dateStr || "").trim();
  const t = String(timeStr || "").trim();
  if (!d || !t) return 0;
  return localInputValueToEpochSec(`${d}T${t}`);
}

export function toReadableTime(sec) {
  const n = Number(sec || 0);
  if (!n) return "—";
  const d = new Date(n * 1000);
  if (Number.isNaN(d.getTime())) return String(sec);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())} ${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())}:${pad2(d.getUTCSeconds())} UTC`;
}
